import React from 'react';
import CalendarHeader from './CalendarHeader/CalendarHeader';
import Today from './CalendarType/Today';

const Calendar = () => (
  <>
    <CalendarHeader title="Today" activeMenu="Today" />
    <Today />
  </>
);

export default Calendar;
